import {
  OrderIntakeFeatureToggleNames,
  orderIntakeFeatureToggles,
  OrderIntakeFeatureToggles
} from '@hconnect/tuc-processes/orderIntake/featureToggles'
import {useMemo} from 'react'

import {NormalizedFeatures, useFeaturesState} from '../../../../Organisms/Features'

/**
 * Hook to get and normalize order intake feature toggles.
 * Converts the global feature state into the format expected by OrderIntakeProcessProvider.
 *
 * @returns OrderIntakeFeatureToggles object
 */
export const useOrderIntakeFeatureToggles = (): OrderIntakeFeatureToggles => {
  const {normalized: normalizedFeatureToggles} = useFeaturesState()

  const isFeatureToggleEnabled = (
    features: NormalizedFeatures,
    feature: OrderIntakeFeatureToggleNames
  ): boolean => features[orderIntakeFeatureToggles[feature]]?.enabled ?? false

  return useMemo(
    () => ({
      enableConfirmationPin: isFeatureToggleEnabled(
        normalizedFeatureToggles,
        orderIntakeFeatureToggles.enableConfirmationPin
      ),
      enableSlotManagementForRmcOrderIntake: isFeatureToggleEnabled(
        normalizedFeatureToggles,
        orderIntakeFeatureToggles.enableSlotManagementForRmcOrderIntake
      ),
      enableOrderIntakeContractSelection: isFeatureToggleEnabled(
        normalizedFeatureToggles,
        orderIntakeFeatureToggles.enableOrderIntakeContractSelection
      )
    }),
    [normalizedFeatureToggles]
  )
}
